import React from "react";
import Logo from "../../images/logo.png";
import MobileMenu from "../../components/MobileMenu";
import "./style.css";

const SECTION_IDS = {
  home: "hero",
  about: "about",
  features: "features",
  workAreas: "work-areas",
  projects: "projects",
};

const Header = (props) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const SCROLL_OFFSET_TOP = 80;

  const scrollToSection = (sectionId) => {
    if (sectionId === "hero") {
      scrollToTop();
      return;
    }
    const el = document.getElementById(sectionId);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET_TOP;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className={`middle-header ${props.ms2}`}>
      {/* <HeaderTopbar /> */}
      <div className="header-style-3">
        <div className="container">
          <div className="header-content">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                <div className="logo">
                  <button type="button" onClick={scrollToTop} className="logo-link" title="">
                    <img src={Logo} alt="" />
                  </button>
                </div>
              </div>
              <div className="col-lg-8 d-lg-block d-none">
                <nav>
                  <ul>
                    <li>
                      <button type="button" className="nav-link" onClick={() => scrollToSection(SECTION_IDS.home)}>
                        الرئيسية
                      </button>
                    </li>
                    <li>
                      <button type="button" className="nav-link" onClick={() => scrollToSection(SECTION_IDS.about)}>
                        عن جذور
                      </button>
                    </li>
                    <li>
                      <button type="button" className="nav-link" onClick={() => scrollToSection(SECTION_IDS.features)}>
                        توجهات جذور
                      </button>
                    </li>
                    <li>
                      <button type="button" className="nav-link" onClick={() => scrollToSection(SECTION_IDS.workAreas)}>
                        مجالات العمل
                      </button>
                    </li>
                    <li>
                      <button type="button" className="nav-link" onClick={() => scrollToSection(SECTION_IDS.projects)}>
                        المشاريع
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="col-lg-1 col-md-6 col-sm-6 col-6"></div>
              <div className="col-md-2 col-sm-2 col-2 mt-0">
                <MobileMenu />
              </div>
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
